import { friendlyMessages } from '../consts/errors'
import i18n from './i18n'

export function getErrorMessage(error) {
    const apiMessage = error?.response?.data?.message
    const statusText = error?.response?.statusText
    const message = apiMessage || error?.message || statusText
    return friendlyMessages[message] || i18n.t('An unexpected error occurred. Please try again later.')
}
